export default "__VITE_ASSET__hCx3wc6N__"